import StarBorderIcon from '@mui/icons-material/StarBorder';
import { Typography, ButtonProps } from '@mui/material';
import { ReactNode, useState } from 'react';
import { ReviewWithSummary } from '@/graphql/__generated/sdk';
import { seeAllReviewsButton } from './ListModal.styles';
import ReviewsList from './ReviewsList';
import TAGButton from '../../TAGButton/TAGButton';
import TAGDialog from '@shared-components/components/TAGDialog';
interface ReviewsListModalProps {
  facilityName: string;
  reviews: ReviewWithSummary;
  buttonText?: string;
  isHero?: boolean;
  buttonVariant?: ButtonProps['variant'];
  textColor?: string;
  textDecoration?: string;
  endIcon?: ReactNode;
}
const getReviewButtonTextStyle = (textColor: string, textDecoration: string) => ({
  color: `var(--mui-palette-${textColor})`,
  textDecoration
});
export default function ReviewsListModal({
  facilityName,
  reviews,
  buttonText = 'See all Reviews',
  isHero = false,
  buttonVariant = 'text',
  textColor = 'info-main',
  textDecoration = 'underline',
  endIcon
}: Readonly<ReviewsListModalProps>) {
  const [dialogOpen, setDialogOpen] = useState(false);
  return <>
			{isHero ? <TAGButton onClick={() => {
      setDialogOpen(true);
    }} id="hero-all-reviews-button" variant="tertiaryDefault" startIcon={<StarBorderIcon sx={{
      fontSize: 20,
      color: 'text.light'
    }} />}>
					<Typography variant="bodyMediumBook" color="text.light" textTransform="capitalize">
						{buttonText}
					</Typography>
				</TAGButton> : <TAGButton onClick={() => {
      setDialogOpen(true);
    }} sx={seeAllReviewsButton} variant={buttonVariant} endIcon={endIcon}>
					<Typography variant="bodySmallBook" textTransform="capitalize" sx={getReviewButtonTextStyle(textColor, textDecoration)}>
						{buttonText}
					</Typography>
				</TAGButton>}
			{dialogOpen ? <TAGDialog open={dialogOpen} handleClose={() => {
      setDialogOpen(false);
    }} title={facilityName} showCloseIcon dialogSx={{
      width: '100%'
    }} renderContent={() => <ReviewsList reviews={reviews.reviews || []} />} /> : null}
		</>;
}